/**
 * 拖拽改变表格列宽
 * Bai.Zhiming
 */
angular.module("colResizableModule",[]).
directive("colResizable",[function(){
	return {
		restrict:"AC",
		replace:false,
		link:function(scope,$element,$attrs){
			$element.colResizable();
		}
	}
}]);